import { render } from "./ListasSection.vue?vue&type=template&id=66f1e20b"
import script from "./ListasSection.vue?vue&type=script&lang=js"
export * from "./ListasSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__